import {
  API_ENDPOINT,
  useClientApiV2VouchersEnrollmentVerificationsQuery,
} from '../../../../../../resources/@types/courseSchema';
import useQueryOptionWithUserId from '../../../../../hooks/useQueryOptionWithUserId';

export default function useVoucherEnrollmentVerificationsQuery(
  options?: Parameters<typeof useClientApiV2VouchersEnrollmentVerificationsQuery>[0]['options'],
) {
  const queryOption = useQueryOptionWithUserId(
    API_ENDPOINT.CLIENT_V2_VOUCHERS_ENROLLMENT_VERIFICATIONS,
  );

  return useClientApiV2VouchersEnrollmentVerificationsQuery({
    url: queryOption.url,
    queryKey: getVoucherEnrollmentVerificationsQueryKey(),
    options: {
      suspense: true,
      useErrorBoundary: false,
      ...options,
    },
  });
}

export const getVoucherEnrollmentVerificationsQueryKey = () => [
  API_ENDPOINT.CLIENT_V2_VOUCHERS_ENROLLMENT_VERIFICATIONS,
];
